import { MuiThemeProvider } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import theme from 'components/lib/theme';
import { Settings } from 'luxon';
import * as React from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import AppContainer from './containers/AppContainer';
import history from './history';
import { configureStore } from './store/store';

function configureDateTime() {
  Settings.defaultZoneName = 'Europe/Oslo';
  Settings.defaultLocale = 'nb';
}

class App extends React.Component {
  private store: any;

  constructor(props: any) {
    super(props);
    this.store = configureStore();
    configureDateTime();
  }

  public render() {
    return (
      <React.Fragment>
        <CssBaseline />
        <Provider store={this.store}>
          <MuiThemeProvider theme={theme}>
            <Router history={history}>
              <React.Fragment>
                <AppContainer />
              </React.Fragment>
            </Router>
          </MuiThemeProvider>
        </Provider>
      </React.Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx